export default [
  /*
  {
    version: '0.0.0',
    added: [],
    changed: [],
    removed: [],
    improvements: [],
    fixes: [],
  },
  */
  {
    version: '2.1.21',
    improvements: [
      'Optimierungen im Hintergrund, um Stabilität und Datenschutz weiterhin zuverlässig zu gewährleisten.',
    ],
  },
  {
    version: '2.1.18',
    added: [
      'Integration Ressourcen-Seite (für Dokumente, Richtlinien, etc.).',
    ],
    changed: [
      'Empfohlene Massnahmen am Hauptförderort → "Integrative Förderung (IF)" ersetzt mit "Heilpädagogische Förderung".',
    ],
  },
  {
    version: '2.1.17',
    changed: [
      'Text des Vertraulichkeitsvermerks in den Berichten wurde aktualisiert.',
    ],
    removed: [
      'Entfernung Umfrage 2025.',
    ],
  },
  {
    version: '2.1.16',
    improvements: [
      'Erhöhte System-Sicherheit: nach einem administrativen Passwort-Reset ist nun eine sofortige Änderung durch den Benutzer erforderlich.',
    ],
  },
  {
    version: '2.1.15',
    improvements: [
      'Kommentare welche <strong>nicht</strong> mit einer Änderung zusammenhängen, konnten nicht dargestellt werden im Überprüfungsmodus. Dies ist nun möglich.',
    ],
  },
  {
    version: '2.1.11',
    improvements: [
      'Fall-Versionen können nun zu jedem Zeitpunkt eingesehen / ausgewählt werden.',
    ],
  },
  {
    version: '2.1.10',
    improvements: [
      'Kleinere Anpassungen am Überprüfungs-Modus.',
    ],
  },
  {
    version: '2.1.9',
    improvements: [
      'Sicherstellung, dass sich die Darstellung beim Wechsel der Ansichtsfilter korrekt aktualisiert.',
    ],
  },
  {
    version: '2.1.8',
    changed: [
      'Ansicht «Alle EDK-Daten» wurde deaktiviert und ausgeblendet.',
      'Die neue Standardansicht ist nun «SAV ZH Bericht»',
    ],
  },
  {
    version: '2.1.7',
    fixes: [
      'Die Revalidierung der Benutzerauthentifizierung führte zum kompletten Neuladen der Falldaten (Sprung an den Anfang der Fallübersicht).',
    ],
  },
  {
    version: '2.1.6',
    fixes: [
      'Behebung eines Fehlers, der das Eröffnen neuer Fälle verhinderte.',
    ],
  },
  {
    version: '2.1.5',
    improvements: [
      'Kommentarfunktion im Überprüfungsmodus war nicht sichtbar.',
      'Kleinere Optimierungen am Anwendungsverhalten.',
    ],
  },
  {
    version: '2.1.4',
    changed: [
      'Erweiterungen an der Fehlerbehebungs-Schnitstelle.',
    ],
  },
  {
    version: '2.1.2',
    added: [
      'Integration eines Fehler-Überwachungssystems zur proaktiven Identifizierung und Behebung von Fehlern, um die Zuverlässigkeit der Anwendung zu erhöhen.',
    ],
  },
  {
    version: '2.1.1',
    added: [
      '<b>Lokale Sicherheit:</b> Ihre Arbeit wird nun zusätzlich kontinuierlich lokal gesichert.',
      '<b>Integrierte Konfliktlösung:</b> Sollten Abweichungen zur Server-Version auftreten, unterstützt Sie ein Konfliktlösungs-Popup dabei,<br/> den korrekten Bearbeitungsstand sicher zu übernehmen.',
    ],
    changed: [
      'ICD/DSM-Erfassung → Verdachtsdiagnosen: gehören nun zu den kantonalen Daten.',
    ],
  },
  {
    version: '2.0.17',
    changed: [
      'Feld «Grund SAV» erlaubt nun Mehrfach-Auswahl',
      'Feld «Postleitzahl» ist nun eine Bezirks-Angabe',
      'Kleinere textuelle Anpassungen für Feld-Bezeichnungen',
    ],
  },
  {
    version: '2.0.16',
    added: [
      'Suchfunktion nach Personen für Fall-Umteilungen und "Gegenlesende Fachperson"',
    ],
    changed: [
      'Kleinere Text-Änderungen für Infotexte',
    ],
  },
  {
    version: '2.0.15',
    changed: [
      'Verbesserte Seitenränder für Word-Exporte',
      'Weitere Anpassungen an den Dropdowns für Ortschaften / Postleitzahlen',
    ],
  },
  {
    version: '2.0.14',
    changed: [
      'Anpassung an den Ortschaften / Postleitzahlen Dropdowns',
      'Diverse kleinere UI Text-Anpassungen',
      'Verbesserte Fallkonvertierung von v1 zu v2',
    ],
    improvements: [
      'Änderungen an ICD-Diagnosen konnten nicht akzeptiert werden in der Fertigstellung',
    ],
  },
  {
    version: '2.0.13',
    changed: ['Anpassungen für neue Frontseite der PDF- / Word-Exporte'],
  },
  {
    version: '2.0.12',
    summary: {
      title: 'Ein Umfangreiches Update',
      description: [
        'Das <strong>SAV-Tool 2.0</strong> bringt zahlreiche Verbesserungen in der Fallverwaltung, neue Verhalten für Diagnosen und Berichte sowie eine optimierte Benutzerführung. Zudem gibt es Erweiterungen bei der elektronischen Signatur, bessere Word- und PDF-Berichte und viele weitere Detailverbesserungen.',
      ],
    },
    more: true,
  },
  {
    version: '1.0.36',
    changed: ['Anpassung Werte-Bezeichnung in «Besondere Massnahmen am Hauptförderort» im professionellen Kontext'],
  },
  {
    version: '1.0.35',
    added: ['Aktualisierung der Jahrgänge'],
  },
  {
    version: '1.0.34',
    changed: ['Hinweis auf Ad-Blocker bei Support Videos'],
  },
  {
    version: '1.0.33',
    improvements: ['Support Videos wurden nicht mehr richtig dargestellt'],
  },
  {
    version: '1.0.32',
    changed: ['Interne Anpassungen für verbesserten Support'],
  },
  {
    version: '1.0.31',
    improvements: ['Verbesserte Wiederherstellung von archivierten Fällen.'],
  },
  {
    version: '1.0.30',
    improvements: ['Entfernung von ungültigen Zeichen bei Word-Export verbessert.'],
  },
  {
    version: '1.0.29',
    changed: ['Fälle können nun ohne Angabe von Vornamen/Nachnamen abgespeichert werden.'],
  },
  {
    version: '1.0.28',
    changed: ['VSA interne Anpassungen'],
  },
  {
    version: '1.0.27',
    changed: ['Layoutanpassungen an PDF- / Word-Export.'],
  },
  {
    version: '1.0.26',
    changed: [
      'Verbesserungen an der System- und Kommunikationsstabilität.',
      'Durch die obigen Änderungen notwendige Anpassungen am Überprüfungs- und Bearbeitungsmodus',
    ],
  },
  {
    version: '1.0.25',
    improvements: ['Korrektur der Darstellung von Schwerpunkten für Entwicklungs- und Bildungsziele im PDF- / Word-Export.'],
  },
  {
    version: '1.0.24',
    improvements: ['Korrekturen am Verhalten des Überprüfungsmodus.'],
  },
  {
    version: '1.0.23',
    changed: ['Layoutanpassungen an PDF- / Word-Export.'],
  },
  {
    version: '1.0.22',
    added: ['Neu kann Job-Bezeichnung / Titel im Profil hinterlegt werden.'],
  },
  {
    version: '1.0.21',
    added: ['VSA spezifisches, internes Update.'],
  },
  {
    version: '1.0.20',
    changed: [
      'Verbesserungen an der Systemstablilität.',
      'Layoutanpassungen an PDF- / Word-Export.',
    ],
  },
  {
    version: '1.0.19',
    changed: ['Verbesserungen für Support & Unterstützung.'],
  },
  {
    version: '1.0.18',
    added: ['Neue Option hinzugefügt für "Kategorisierung der definitiven Massnahmen".'],
    changed: ['Liste der Schulgemeinden wurde überarbeitet.'],
  },
  {
    version: '1.0.17',
    improvements: ['PDF- / Word-Export in der Überprüfung funktioniert nun wie erwartet.'],
  },
  {
    version: '1.0.16',
    improvements: ['Verschiedene kleinere Optimierungen am System.'],
  },
  {
    version: '1.0.15',
    improvements: ['Korrekturen am Datenabruf in der Überprüfung.'],
  },
  {
    version: '1.0.14',
    added: ['Es ist nun möglich Ausserkantonale SPD\'s zu erfassen.'],
  },
  {
    version: '1.0.13',
    changed: ['Liste der Schulgemeinden wurde überarbeitet und erweitert.'],
  },
  {
    version: '1.0.12',
    changed: ['Kleinere Text-Anpassungen an den PDF- / Word-Exporten.'],
  },
];
